<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ `${product.name}` }} - {{ $t("COMMON.LOGS") }}</h3>
    <log-list-table :filterSubject="product" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "product-view-logs",

  components: { LogListTable },

  props: ["product"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
